import {Component, OnInit, ChangeDetectionStrategy} from '@angular/core';
import { Location, AsyncPipe } from "@angular/common";
import {ActivatedRoute} from "@angular/router";
import {PartySelectedService} from "@portal/shared/services/party-selected.service";
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';

@Component({
    selector: 'app-edit-add-drawer-header',
    templateUrl: './edit-add-drawer-header.component.html',
    styleUrls: ['./edit-add-drawer-header.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [MatButton, MatIcon, AsyncPipe]
})
export class EditAddDrawerHeaderComponent implements OnInit {
    party$ = this._partySelectedService.currentParty;
    mode = "Adicionar"
    pageTitle: string;
    constructor(private _partySelectedService: PartySelectedService,
                private route: ActivatedRoute,
                private location: Location) {

    }

    ngOnInit(): void {
        this.route.data.subscribe(data => {
            this.mode = data.add ? 'Adicionar' : 'Editar';
            this.pageTitle = data.pageTitle;
        });
    }

    goBack() {
        this.location.back();
    }
}
